<template>
  <div v-if="isLoading" class="text-center my-5">
    <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
      <span class="visually-hidden">Chargement...</span>
    </div>
    <p class="mt-2">Chargement des lits...</p>
  </div>

  <div v-else class="container-fluid py-4">

    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-4 header-clinique">
      <div class="d-flex align-items-center gap-3">
        <i class="bi bi-bed fs-2 text-primary"></i>
        <h2 class="fw-bold mb-0">Lits</h2>
      </div>
      <button class="btn btn-primary btn-lg shadow-sm btn-clinique" @click="creation()" v-if="$store.getters.hasPermission('CONFIG_CREER_LIT')">
        <i class="bi bi-plus-circle me-1"></i> Nouveau Lit
      </button>
    </div>

    <!-- Filtres et recherche -->
    <div class="card p-3 mb-4 shadow-sm rounded card-clinique">
      <div class="row g-3 align-items-end">
        <div class="col-md-3">
          <label class="form-label fw-semibold">Rechercher</label>
          <input type="text" v-model="searchQuery" placeholder="Numéro ou chambre..." class="form-control form-control-clinique">
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold">Items par page</label>
          <select v-model="itemsperpage" class="form-select form-select-clinique">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label fw-semibold">Trier par</label>
          <select v-model="orderBy" class="form-select form-select-clinique">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label fw-semibold">Ordre</label>
          <select v-model="sortOrder" class="form-select form-select-clinique">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">{{ key }}</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Tableau moderne -->
    <div class="card shadow-sm rounded card-clinique">
      <div class="table-responsive">
        <table class="table align-middle text-center mb-0 table-hover modern-table-clinique">
          <thead>
            <tr>
              <th>#</th>
              <th>Numéro</th>
              <th>Chambre</th>
              <th>Type Chambre</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(lit, index) in filteredLits" :key="lit.id">
              <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
              <td>{{ lit.numero }}</td>
              <td>{{ lit.chambre?.numero || 'N/A' }}</td>
              <td>{{ lit.chambre?.type.nom || '' }}</td>
              <td>
                <span :class="['badge', lit.isEnabled ? 'bg-success' : 'bg-danger']">
                  {{ lit.isEnabled ? 'Activé' : 'Désactivé' }}
                </span>
              </td>
              <td>
                <div class="dropdown">
                  <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" @click="modifier(lit.id)" v-if="$store.getters.hasPermission('CONFIG_MODIFIER_LIT')">Modifier</a></li>
                    <li><a class="dropdown-item text-danger" @click="supprimer(lit.id)" v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_LIT')">Supprimer</a></li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="lits.length === 0">
              <td colspan="6" class="text-center py-3">Aucune donnée disponible</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end p-3">
        <ul class="pagination pagination-modern mb-0">
          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
          </li>
          <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: page === currentPage }">
            <button class="page-link" @click="changePage(page)">{{ page }}</button>
          </li>
          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  data() {
    return {
      isLoading: true,
      searchQuery: '',
      itemsperpage: 50,
      orderBy: 'li.numero',
      sortOrder: 'asc',
      lits: [],
      totalItems: 0,
      currentPage: 1,
      itemsPerPageT: [50, 100, 150, 200],
      orderByTabs: { Numéro: 'li.numero', Chambre: 'li.chambre', Statut: 'li.isEnabled' },
      sortOrders: { Croissant: 'asc', Décroissant: 'desc' },
      isFirstLoad: true
    };
  },
  computed: {
    filteredLits() {
      if (!this.searchQuery) return this.lits;
      return this.lits.filter(l =>
        l.numero.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        (l.chambre?.numero || '').toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        (l.chambre?.type.nom || '').toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }
  },
  methods: {
    creation() { this.$router.push({ name: 'create_lit' }); },
    async getLits() {
      if (this.isFirstLoad) { this.isLoading = true; this.isFirstLoad = false; }
      try {
        const response = await api.getItems('lits', {
          orderBy: this.orderBy, sortOrder: this.sortOrder, itemsperpage: this.itemsperpage,
          page: this.currentPage, search: this.searchQuery
        });
        const { data, meta } = response.data;
        this.lits = data;
        this.totalItems = meta?.total_records || data.length;
      } catch (error) {
        console.error('Erreur lors du chargement des lits :', error);
      } finally { this.isLoading = false; }
    },
    changePage(page) { if (page > 0 && page <= this.totalPages) this.currentPage = page; this.getLits(); },
    modifier(id) { this.$router.push({ name: 'edit_lit', params: { id } }); },
    async supprimer(id) {
      if (!window.confirm("Voulez-vous vraiment supprimer ce lit ?")) return;
      try { this.isLoading = true; await api.deleteItem('lits', id); this.getLits(); }
      catch (error) { alert("Erreur lors de la suppression."); }
      finally { this.isLoading = false; }
    }
  },
  watch: {
    searchQuery() { this.currentPage = 1; this.getLits(); },
    itemsperpage() { this.currentPage = 1; this.getLits(); },
    orderBy() { this.getLits(); },
    sortOrder() { this.getLits(); }
  },
  created() { this.getLits(); }
};
</script>

<style scoped>
.header-clinique {
  padding: 15px 20px;
  background-color: #e9f5ff;
  border-radius: 12px;
  margin-bottom: 20px;
}
.card-clinique {
  background: #f8fafd;
  border-radius: 12px;
  border: none;
}
.form-control-clinique, .form-select-clinique {
  border-radius: 10px;
  border: 1px solid #d1e3f0;
  padding: 8px 12px;
  transition: all 0.3s ease;
}
.form-control-clinique:focus, .form-select-clinique:focus {
  box-shadow: 0 0 6px #0d6efd33;
  border-color: #0d6efd;
}
.btn-clinique {
  background: linear-gradient(90deg, #0d6efd, #6610f2);
  border: none;
  color: #fff;
  border-radius: 10px;
  transition: all 0.3s ease;
}
.btn-clinique:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
  transform: translateY(-2px);
}
.modern-table-clinique thead {
  background: linear-gradient(90deg, #8fd3f4, #0d6efd);
  color: #fff;
  font-weight: 600;
}
.modern-table-clinique tbody tr:hover {
  background-color: #e1f0ff;
  cursor: pointer;
  transition: all 0.3s ease;
}
.badge {
  font-size: 0.85rem;
  padding: 0.4em 0.7em;
  border-radius: 12px;
}
.pagination-modern .page-link {
  border-radius: 50% !important;
  margin: 0 4px;
  min-width: 38px;
  min-height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0d6efd;
  border: 1px solid #dee2e6;
}
.pagination-modern .page-item.active .page-link {
  background-color: #0d6efd;
  color: #fff;
  border-color: #0d6efd;
}
.pagination-modern .page-link:hover {
  background-color: #d1e7ff;
  transition: all 0.3s ease;
}
</style>
